import { HighlightedText } from '@/components';
import type { HelpSearchResultRowProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';

// Keep highlighted words in the snippet's own color; only the weight changes.
const HIGHLIGHT_STYLE = { color: 'inherit', fontWeight: 600 };

const HelpSearchResultRow = ({
  id,
  result,
  active,
  onHover,
  onSelect,
}: HelpSearchResultRowProps) => {
  return (
    <div
      id={id}
      role='option'
      aria-selected={active}
      className={`${styles.helpSearchResult} ${
        active ? styles.helpSearchOptionActive : ''
      }`}
      onMouseEnter={onHover}
      onClick={onSelect}
    >
      <span className={styles.helpSearchResultCategory}>{result.category}</span>
      <span className={styles.helpSearchResultTitle}>
        <span className={styles.helpSearchResultTitleText}>{result.title}</span>
        {result.is_new && <span className={styles.helpNewPill}>New</span>}
      </span>
      <HighlightedText
        className={styles.helpSearchResultSnippet}
        text={result.snippet}
        highlightedSections={result.highlights?.map(([start, end]) => ({
          text: '',
          start_index: start,
          end_index: end,
        }))}
        highlightStyle={HIGHLIGHT_STYLE}
      />
    </div>
  );
};

export default HelpSearchResultRow;
